import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["primary", "confirmation", "message", "submit"]

  connect() {
    this.check()
  }

  check() {
    const pairs = this.collectPairs()
    let allValid = true

    pairs.forEach(({ primary, confirmation, message }) => {
      const normalize = primary.type === "email" ? (v) => v.toLowerCase().trim() : (v) => v
      const primaryValue = normalize(primary.value)
      const confirmationValue = normalize(confirmation.value)

      if (confirmationValue === "") {
        this.clearError(confirmation, message)
        allValid = false
        return
      }

      if (primaryValue === confirmationValue) {
        this.clearError(confirmation, message)
      } else {
        this.showError(confirmation, message)
        allValid = false
      }
    })

    this.setSubmitDisabled(!allValid)
  }

  collectPairs() {
    const pairs = {}

    const ensure = (name) => {
      pairs[name] ||= { name }
      return pairs[name]
    }

    this.primaryTargets.forEach((el) => {
      ensure(el.dataset.pair).primary = el
    })

    this.confirmationTargets.forEach((el) => {
      ensure(el.dataset.pair).confirmation = el
    })

    this.messageTargets.forEach((el) => {
      ensure(el.dataset.pair).message = el
    })

    return Object.values(pairs).filter((p) => p.primary && p.confirmation && p.message)
  }

  showError(confirmationEl, messageEl) {
    const formGroup = confirmationEl.closest(".form-group")
    if (formGroup) formGroup.classList.add("has-error")

    const text = messageEl.dataset.mismatchMessage || "Does not match"
    messageEl.replaceChildren()
    const icon = document.createElement("i")
    icon.className = "far fa-exclamation-circle"
    icon.setAttribute("aria-hidden", "true")
    messageEl.appendChild(icon)
    messageEl.appendChild(document.createTextNode(` ${text}`))
    messageEl.hidden = false
  }

  clearError(confirmationEl, messageEl) {
    const formGroup = confirmationEl.closest(".form-group")
    if (formGroup) formGroup.classList.remove("has-error")

    messageEl.replaceChildren()
    messageEl.hidden = true
  }

  setSubmitDisabled(disabled) {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = disabled
    }
  }
}